module.exports = __webpack_public_path__ + "img/404.801f547e.png";